<div class="p"><p><strong> ensure documents being submitted are clear and visible, any document that is not clear and visible will be rejected.</strong></p>
<p><strong>All foreign documents must be translated by certified translator in English </strong></p>
</div>

<h1>SARS TAX Clearance Status or SARS TAX Clearance Certificate</h1>

<div class="center">icon <br>Drag and drop files here or search on your computer<br> <span style="text-decoration: underline;color: #274C9C;">Upload file</span></div>
<span style="font-size: 15px;">Max file size 5MB PDF format</span>
<br>   
<h2>Files Uploaded(0)</h2>

<!-- <h1>Company Registration</h1>

<div class="center">icon <br>Drag and drop files here or search on your computer<br> <span style="text-decoration: underline;color: #274C9C;">Upload file</span></div>
<span style="font-size: 15px;">Max file size 5MB PDF format</span>
<br>   
<h2>Files Uploaded(0)</h2> -->